// extracted by mini-css-extract-plugin
export var bubble = "_3k-0";
export var container = "_3k-f";
export var contrastBorder = "_3k-g";
export var greyOut = "_3k-2";
export var initialsColor0 = "_3k-3";
export var initialsColor1 = "_3k-4";
export var initialsColor10 = "_3k-d";
export var initialsColor11 = "_3k-e";
export var initialsColor2 = "_3k-5";
export var initialsColor3 = "_3k-6";
export var initialsColor4 = "_3k-7";
export var initialsColor5 = "_3k-8";
export var initialsColor6 = "_3k-9";
export var initialsColor7 = "_3k-a";
export var initialsColor8 = "_3k-b";
export var initialsColor9 = "_3k-c";
export var initialsWrapper = "_3k-1";
export var large = "_3k-l";
export var medium = "_3k-k";
export var mediumSmall = "_3k-j";
export var mediumSmallMedium = "_3k-o";
export var micro = "_3k-h";
export var small = "_3k-i";
export var tiny = "_3k-n";
export var xTiny = "_3k-m";